/**
 * 服务管理类型定义
 * 包含服务相关的接口、类型和常量
 */

// 服务记录接口
export interface ServiceRecord {
  id: string;
  key: string;
  name: string;
  displayName: string;
  description?: string;
  status: string; // "online" | "offline" | "maintenance"
  healthCheckUrl?: string;
  lastHealthCheck?: string;
  version?: string;
  icon?: string;
  color?: string;
  isSystemService?: boolean; // 是否为系统服务
  service_status?: number | string;

  // 新增字段 - UI显示相关
  service_description?: string;
  icon_name?: string;

  // 新增字段 - 路由和导航相关
  routePath?: string;
  menuOrder?: number;
  isMenuItem?: boolean;
  route_path?: string;
  menu_order?: number;
  is_menu_item?: boolean;

  // 新增字段 - 服务配置相关
  backendUrl?: string;
  url?: string;
  service_url?: string;
  service_endpoint?: string;
  requiresAuth?: boolean;
  requires_auth?: boolean;
  health_check_url?: string;

  // 新增字段 - 权限相关
  permissions?: string[];
  external?: boolean;
  isExternal?: boolean;
  is_external?: boolean;

  // Token相关字段
  has_token?: boolean;
  token_info?: {
    token_id?: string;
    token_value?: string;
    expires_at?: string;
    is_active?: boolean;
    last_used_at?: string;
    usage_count?: number;
    max_usage?: number;
  };
  allowed_audience?: string[];
  // 健康状态
  healthStatus?: boolean;
  // 权限相关字段
  registered_operations?: number; // 注册的授权操作数量
  actual_permissions_count?: number; // 实际权限操作数量（动态计算）
  service_name?: string;
  display_name?: string;
  // 服务秘钥字段
  service_secret?: string;
  // 服务类型字段（0=系统，1=后台，2=中台，3=前台）
  serviceType?: number;
  service_type?: number;
}

// 服务状态映射配置
export const SERVICE_STATUS_MAP = {
  online: { text: "可用", color: "success" },
  offline: { text: "不可用", color: "error" },
  maintenance: { text: "维护中", color: "warning" },
} as const;

// 表格操作接口（保留用于类型定义）
export interface ServiceTableActions {
  onEdit: (record: ServiceRecord) => void;
  onDelete: (record: ServiceRecord) => void;
  onToggleStatus: (record: ServiceRecord) => void;
  onManageToken: (record: ServiceRecord) => void;
  onViewPermissions: (record: ServiceRecord) => void;
  onHealthCheck: (record: ServiceRecord) => void;
}

